export function extractParticipantNamesFromRsvps(rsvps, options = {}) {
    const includeMaybe = options.includeMaybe !== false;
    const includeNotGoing = options.includeNotGoing === true;
    const names = [];

    const addNames = (list) => {
        if (!Array.isArray(list)) return;
        list.forEach((entry) => {
            if (!entry) return;
            const name = entry.userName || entry.displayName;
            if (typeof name !== 'string') return;
            const trimmed = name.trim();
            if (trimmed) names.push(trimmed);
        });
    };

    addNames(rsvps && rsvps.going);
    if (includeMaybe) addNames(rsvps && rsvps.maybe);
    if (includeNotGoing) addNames(rsvps && rsvps.notGoing);

    return Array.from(new Set(names));
}

export function prefillSessionParticipants({
    names,
    setParticipants,
    renderParticipants,
    updateOrganizeButton,
    groupsDisplay,
    participantNameInput,
    showMessage,
    eventTitle
}) {
    const safeNames = Array.isArray(names) ? names : [];
    if (typeof setParticipants === 'function') {
        setParticipants([...safeNames]);
    }

    if (participantNameInput) {
        participantNameInput.value = '';
    }

    if (typeof renderParticipants === 'function') {
        renderParticipants();
    }

    if (typeof updateOrganizeButton === 'function') {
        updateOrganizeButton();
    }

    if (groupsDisplay) {
        groupsDisplay.style.display = 'none';
    }

    if (typeof showMessage === 'function') {
        if (safeNames.length === 0) {
            showMessage('No RSVP participants to load.', 'error');
        } else if (eventTitle) {
            showMessage(`Loaded ${safeNames.length} participant${safeNames.length === 1 ? '' : 's'} from "${eventTitle}" RSVPs.`, 'success');
        } else {
            showMessage(`Loaded ${safeNames.length} participant${safeNames.length === 1 ? '' : 's'} from RSVPs.`, 'success');
        }
    }
}
